// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { IImageSchema } from '../image/ImageSchema';

export interface IConstructorV3Schema {
  /** Год основания **/
  foundationYear: number;
  /** Идентификатор компании **/
  id: number;
  /** Главные фото проектов **/
  images: IImageSchema[];
  /** Ссылка на логотип компании **/
  logo: string;
  /** Материалы из которых делают дома **/
  materials: string[];
  /** Наименование бренда **/
  name: string;
  /** Дополнительные материалы из которых делают дома **/
  otherMaterials?: string;
  /** Телефон компании **/
  phone: string;
  /** Минимальная цена типового проекта **/
  projectStartPrice: number;
  /** Типы проектов **/
  projectsType: EProjectsType[];
}
export enum EProjectsType {
  /** Типовой **/
  'Common' = 'common',
  /** Индивидуальный **/
  'Individual' = 'individual',
}
